import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WidgetFilter, WidgetUserFilter } from '../classes';
import { serverLocation } from '../globals';
import { TokenService } from '../lib/shared/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor(
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) { }

  createUserFilter(filter: WidgetUserFilter): Observable<WidgetUserFilter> {
    return this._httpClient.post(`${serverLocation}/api/user-filter`, filter, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<WidgetUserFilter>;
  }

  deleteFilter(filterId: number): Observable<Object> {
    return this._httpClient.delete(`${serverLocation}/api/filter/${filterId}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<Object>;
  }

  shareUserFilter(filterId: number, userId: string): Observable<Object> {
    return this._httpClient.get(`${serverLocation}/api/user-filter/${filterId}/share-filter/${userId}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<Object>;
  }

  updateUserFilter(filter: WidgetUserFilter): Observable<WidgetUserFilter> {
    return this._httpClient.put(`${serverLocation}/api/user-filter`, filter, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<WidgetUserFilter>;
  }

  updateUserFilterSorting(filterId: number, sortAttribute: string, sortDesc: boolean): Observable<WidgetFilter> {
    return this._httpClient.get(`${serverLocation}/api/user-filter/${filterId}/update-sorting/${sortAttribute}/${sortDesc}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<WidgetFilter>;
  }
}
